import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.prototype.$sitios = ['Los Andes Coworking', 'Sam Coworking', 'Margarita Coworking', 'VIMORCA', 'La Rama Dorada', 'Red Bona Via']
new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
